<template>
  <div class="back_video">
    <img @click="goBack_video" src="@/assets/back_video.png" alt="">
    <img v-show='baseData&&baseData.home_page_id' @click="goHome_video" src="@/assets/编组 6@2x (1).png" alt="">
  </div>
</template>

<script>
export default {
  props: ['baseData'],
  methods: {
    goHome_video() {
      this.$router.push('/?view_id=' + this.baseData.home_page_id)
    },
    goBack_video() {
      if (document.referrer == window.location.href) {
        this.$router.push('/?view_id=' + this.baseData.home_page_id)
      } else {
        if (window.history.length > 1) {
          if (Boolean(navigator.userAgent.match(/iphone|ipod|iOS/ig)) || Boolean(navigator.userAgent.match(/ipad/ig))) {
            history.go(-1)
          } else {
            window.history.go(-1)
          }
        } else if (this.baseData.home_page_id) {
          this.$router.push('/?view_id=' + this.baseData.home_page_id)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.back_video {
  width: 40px;
  bottom: 64px;
  position: fixed;
  right: 12px;
  margin: auto;
  img {
    width: 40px;
  }
}
</style>